import { render, staticRenderFns } from "./PickerArea.vue?vue&type=template&id=0959fb10&scoped=true&"
import script from "./PickerArea.vue?vue&type=script&lang=js&"
export * from "./PickerArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0959fb10",
  null
  
)

export default component.exports